import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Copy, Ellipsis } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function LegislationInstrumentPopupMenu({
  handleCopyLinkLexomat,
  handleCopyLinkSlovLex,
  showSlovLex = true,
}: {
  handleCopyLinkLexomat: () => void;
  handleCopyLinkSlovLex: () => void;
  showSlovLex?: boolean;
}) {
  const t = useTranslations(
    'LegislationDetails.legislationInstrumentPopupMenu'
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant='outline'
          className='bg-brand-primary-color hover:bg-brand-primary-color/90 border-brand-primary-color p-0'
          style={{
            width: '20px',
            height: '20px',
          }}
        >
          <Ellipsis className='w-4 h-4 text-white m-1' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-44'>
        <DropdownMenuLabel className='text-brand-primary-color'>
          {t('title')}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            onClick={handleCopyLinkLexomat}
            className='hover:bg-brand-primary-color/10 focus:bg-brand-primary-color/10 focus:ring-2 focus:ring-brand-primary-color/20 cursor-pointer'
          >
            <Copy className='mr-2 h-4 w-4 text-brand-primary-color' />
            <span className='text-brand-primary-color'>
              {t('copyLinkLexomat')}
            </span>
          </DropdownMenuItem>
          {showSlovLex && (
            <DropdownMenuItem
              onClick={handleCopyLinkSlovLex}
              className='hover:bg-brand-primary-color/10 focus:bg-brand-primary-color/10 focus:ring-2 focus:ring-brand-primary-color/20 cursor-pointer'
            >
              <Copy className='mr-2 h-4 w-4 text-brand-primary-color' />
              <span className='text-brand-primary-color'>
                {t('copyLinkSlovLex')}
              </span>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
